export const RECEIVE_GOOGLE_USER = 'RECEIVE_GOOGLE_USER';
export const REQUEST_GOOGLE_USER = 'REQUEST_GOOGLE_USER';
export const DELETE_GOOGLE_USER = 'DELETE_GOOGLE_USER';
export const REQUEST_CURRENT_USER = 'REQUEST_CURRENT_USER';
export const RECEIVE_CURRENT_USER = 'RECEIVE_CURRENT_USER';
